import { InfoOutlined } from "@mui/icons-material";
import { Box, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

import { TrendIcon } from "./TrendIcon";

export interface MetricCardProps {
  icon: React.ReactNode;
  title: string;
  value: string | number;
  trend?: number;
  sublabel?: string;
  tooltip?: string;
  onClick?: () => void;
  isLoading?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({ icon, title, value, trend, sublabel, tooltip, onClick, isLoading = false }) => {
  return (
    <Paper
      sx={{
        p: 2,
        height: "100%",
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick ? {
          bgcolor: "action.hover"
        } : {}
      }}
      onClick={onClick}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>
        <Box sx={{ mr: 1 }}>{icon}</Box>
        <Typography variant="subtitle1" sx={{ color: grey[600] }}>{title}</Typography>
        {tooltip && (
          <Tooltip title={tooltip} arrow placement="top">
            <IconButton size="small" sx={{ p: 0.5, ml: 0.5 }} onClick={(e) => e.stopPropagation()}>
              <InfoOutlined sx={{ fontSize: 18, color: "text.secondary" }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100% - 40px)" }}>
          <Box sx={{ display: "inline-block", position: "relative", width: 40, height: 40 }}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "4px solid rgba(25, 118, 210, 0.2)",
                borderRadius: "50%",
                borderTop: "4px solid rgba(25, 118, 210, 1)",
                animation: "spin 1s linear infinite",
                "@keyframes spin": {
                  "0%": { transform: "rotate(0deg)" },
                  "100%": { transform: "rotate(360deg)" }
                }
              }}
            />
          </Box>
        </Box>
      ) : (
        <>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="h4" sx={{ mb: 1, color: "#1976d2" }}>{value}</Typography>

            {trend && (
              <>
                <TrendIcon trendPercentage={trend} />
                <Typography
                  variant="body2"
                  color={trend > 0 ? "success.main" : "error.main"}
                  sx={{ ml: 0.5 }}
                >
                  {trend}%
                </Typography>
              </>
            )}
          </Box>
          {sublabel && (
            <Typography variant="body2" color="text.secondary" sx={{ color: grey[600] }}>{sublabel}</Typography>
          )}
        </>
      )}
    </Paper>
  );
};

export default MetricCard;
